export const navigateToLogin = () => {
  window.location.href = '/login';
};
